import { Outlet, useLocation } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorPage } from '@pages/ErrorPage.jsx'

/**
 * RouterProvider 하위 최상위 ErrorBoundary
 * - Router 상태를 유지하면서 에러 처리
 * - 전역 에러 리스너 포함
 */
const RootErrorBoundary = () => {
  const location = useLocation()

  return (
    <ErrorBoundary key={`${location.pathname}-${location.key}`} FallbackComponent={ErrorPage}>
      <Outlet />
    </ErrorBoundary>
  )
}

export default RootErrorBoundary